import { ISvgIconProps, } from './interface';
import { SvgIcon, } from './SvgIcon';

export const FilterIcon = (props: ISvgIconProps) => {
  return <SvgIcon {...props}>
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
  </SvgIcon>;
};
